module.exports = "<form>\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\">Are you sure that you want to send completed ticket?</h3>\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.send()\">Send</button>\n        <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.cancel()\">Cancel</button>\n    </div>\n</form>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/tickets/templates/confirm.send.modal.html
// module id = 659
// module chunks = 0